import React, { memo, useEffect, useState } from 'react';
import { Modal, Button, FormControl } from 'react-bootstrap';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const LostStillageModal = ({ showModal, setShowModal, modalData, onUpdateStillage }) => {
    const [comment, setComment] = useState(() => modalData?.stillageComment ?? '');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setComment(modalData?.stillageComment ?? '');
    }, [modalData]);

    // Check if this has been pinged in the last week
    const lastTrack = dayjs(modalData?.lastTrack);
    const recentPing = lastTrack.isAfter(dayjs().subtract(1, 'week')) && !modalData?.lostStillage;
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered
            size="xl"
            animation={false}
            scrollable
            restoreFocus={false}
            enforceFocus={false}
            autoFocus={false}>
            <Modal.Header>
                <Modal.Title>Mark Stillage {modalData?.stillageNo} as {modalData?.lostStillage ? 'Active' : 'Lost'}?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    !recentPing ?
                        <>
                            <p>Please enter a reason below</p>
                            <FormControl
                                as="textarea"
                                rows={4}
                                value={comment}
                                onChange={e => setComment(e.target.value)}
                            />
                        </> :
                        <p className='text-danger text-center'><b>Cannot change status of a recently pinged stillage!</b></p>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading || recentPing}
                    variant="primary"
                    onClick={() => onUpdateStillage(comment,
                        !modalData?.lostStillage,
                        modalData?.stillageId,
                        modalData?.stillageNo,
                        modalData?.stillageComment,
                        setLoading)}
                >Save</Button>
                <Button disabled={loading} variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

LostStillageModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    modalData: PropTypes.object,
    onUpdateStillage: PropTypes.func
};

export default memo(LostStillageModal);